import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import { Form, Formik } from 'formik'
import { InputField } from 'components'
import adminUpdatePasswordSchema from 'domains/admin/organisms/admin-update-password-form/admin-update-password-schema'

const propTypes = {
  admin: PropTypes.shape({
    current_password      : PropTypes.string,
    new_password          : PropTypes.string,
    password_confirmation : PropTypes.string
  }),
  buttonText        : PropTypes.string,
  handleSubmitForm  : PropTypes.func.isRequired,
  onResetPassword   : PropTypes.func
}

const defaultProps = {
  buttonText: 'Update Password',
  onResetPassword: undefined
}

const AdminForm = ({ handleSubmitForm, onResetPassword, buttonText }) => {

  const initialValues = {
    current_password      : '',
    new_password          : '',
    password_confirmation : ''
  }

  return (
    <Formik
      enableReinitialize= { true }
      initialValues={ initialValues }
      validationSchema={ adminUpdatePasswordSchema }
      onSubmit={ (values, formikBag) => handleSubmitForm(values, formikBag) }
    >
      {
        (formikBag) => (
          <Form>
            <InputField
              name="current_password"
              label="Current Password"
              type="password"
            />

            <InputField
              name="new_password"
              label="New Password"
              type="password"
            />

            <InputField
              name="password_confirmation"
              label="Password Confirmation"
              type="password"
            />
            <div className="d-flex gap-2">
              <Button
                color="primary"
                disabled={formikBag.isSubmitting}
                onClick={() => formikBag.submitForm()}
              >
                {buttonText}
              </Button>
              <Button
                type="button"
                outline
                color="warning"
                className="ml-2"
                disabled={formikBag.isSubmitting}
                onClick={() => {
                  if (!onResetPassword) return
                  if (window.confirm('Generate a one-time temporary password? You will be logged out and must change it after login.')) {
                    onResetPassword()
                  }
                }}
              >
                Reset Password
              </Button>
            </div>
          </Form>
        )
      }
    </Formik>
  )
}

AdminForm.propTypes = propTypes
AdminForm.defaultProps = defaultProps

export default AdminForm
